import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import React, { useRef, useEffect } from 'react';
import { setWorkspaceData } from 'store/slices/workspaceSlice';
import { useDispatch, useSelector } from 'react-redux';
import {
    eventapi,
    tourGuideApi,
  } from 'utils/envsetup';
import useEventTrace from 'utils/CommonRequestConfig';
import useAxiosFlowFunction from 'hooks/useAxiosFlowFunction';
import axios from 'utils/axiosInstance';

export const handleProductTourEvents = async (getProductTourReqConfig,axiosFetch,title,eventSubModule,eventModule) => {
 
  try {
    const reqBody = getProductTourReqConfig()
    await axiosFetch({
      axiosInstance: axios,
      method: 'POST',
      url: eventapi,
      requestConfig: {
        ...reqBody,
        eventModule,
        eventSubModule,
        eventAction:title,
      },
    });
  } catch (error) { 
    console.error("No response received from the server");     
  }
};

export const getGuidedTourSteps= async (authFlowType,axiosFetch,pageName,templateId) => {
 try {
  const tourSteps =  await axiosFetch({
      axiosInstance: axios,
      method: 'POST',
      url: tourGuideApi,
      requestConfig: {
        authFlowType,
        pageName,
        templateId,
      },
    });
    return tourSteps;
  } catch (error) { 
    console.error("No response received from the server");     
  }
};


const ProductTour = () => {
    const {getProductTourReqConfig} = useEventTrace();
    const [, , , axiosFetch] = useAxiosFlowFunction({ isWorkspace: true });
    const {isHeaderTour,tourForApptemplate} = useSelector(state => state.workSpace);
    const {showStudioTour} = useSelector(state => state.workSpace);
    const dispatch = useDispatch();
    const tourRef = useRef(null);
    const pageName = window.location.pathname.replace("/","").replace("-","_").toLocaleUpperCase();
    let eventSubModule;
    if(showStudioTour?.isTourForcreateTemp){
      eventSubModule ="APP_TEMPLATE";
    }else{
    eventSubModule = isHeaderTour? pageName+"_HEADER":pageName;
    }
    const selectedWorkspace = useSelector(state => state.workSpace.selectedWorkspace);
     const tourGuide =  (steps) => {
    let tempStep = steps;

       if(selectedWorkspace?.application?.length === 0 || !selectedWorkspace?.application){
        tempStep = steps.filter(step => step.element !== '#tour_moreoptions');
       }

       const activeTabButtonFlow = document.querySelector('.editor-left-pw-tab .nav-link.active');

      if(pageName === "FLOW_EDITOR"){
        if(document.getElementById('tour_floweditor_collapse') && document.querySelector('.icon-ico_side-panel-open-1')){
          const activeTabId = ["#editorLeftPageWidgetTab-tab-actions","#tour_actionflow_flow", "#tour_actionflow_collection","#editorLeftPageWidgetTab-tab-flows","#tour_actionflow_test_flow"];
          tempStep = tempStep.filter(step => !activeTabId.includes(step.element));
        }
        if (!document.getElementById('tour_actionflow_execlog')) {
          tempStep = tempStep.filter(step => step.element !== '#tour_actionflow_execlog');
        }
        if (isHeaderTour && !document.getElementById('tour_actionflow_test_flow')) {
          tempStep = tempStep.filter(step => step.element !== "#tour_actionflow_test_flow");
        }
        if (activeTabButtonFlow) {
        const activeTabId = activeTabButtonFlow.id === "editorLeftPageWidgetTab-tab-actions"?["#tour_actionflow_flow", "#tour_actionflow_collection"]:[];
        tempStep = tempStep.filter(step => !activeTabId.includes(step.element));
      }
      }

      const activeTabButtonPage = document.querySelectorAll('[class*="PageEditormain_pw-tab__"] .nav-link.active');
    
      if(pageName === "PAGE_EDITOR"){
        if(document.getElementById('left') && document.querySelector('.closed')){
        const activeTabId = ["#tour_pageeditor_createpage","#tour_pageeditor_addtemplate","#editorLeftPageWidgetTab-tab-widgets","#editorLeftPageWidgetTab-tab-elements","#editorLeftPageWidgetTab-tab-prebuiltsections","#editorLeftPageWidgetTab-tab-pages","#editorLeftPageWidgetTab-tab-reusables","#tour_pageeditor_properties","#uncontrolled-tab-example-tab-Visual","#uncontrolled-tab-example-tab-interaction","#tour_pageeditor_responsive"];
        tempStep = tempStep.filter(step => !activeTabId.includes(step.element));
      }
      if (activeTabButtonPage) {
        [...activeTabButtonPage]?.map(activeTab=>{
        let activeTabId=[];
        if(activeTab.id?.includes("editorLeftPageWidgetTab-tab-widgets")){
        activeTabId = [...activeTabId,"#tour_pageeditor_createpage","#tour_pageeditor_addtemplate","#editorLeftPageWidgetTab-tab-widgets"];
        }
        if(activeTab.id?.includes("editorLeftPageWidgetTab-tab-pages")){
        activeTabId = [...activeTabId, "#editorLeftPageWidgetTab-tab-elements","#editorLeftPageWidgetTab-tab-prebuiltsections","#editorLeftPageWidgetTab-tab-pages","#editorLeftPageWidgetTab-tab-reusables"];
        }if (activeTab.id?.includes("uncontrolled-tab-example-tab-interaction")) {
        activeTabId =[...activeTabId, "#tour_pageeditor_properties","#tour_pageeditor_responsive"]
        }
       if(activeTab.id?.includes("uncontrolled-tab-example-tab-Visual")){
        activeTabId = [...activeTabId, "#uncontrolled-tab-example-tab-Visual", "#uncontrolled-tab-example-tab-interaction"];
      }
      tempStep = tempStep.filter(step => !activeTabId.includes(step.element));
    })
    }
  }
    
     
    if(pageName === "RESOURCE_EDITOR"){
      if( !document.getElementById('tour_resourceeditor_menuopen')){
        if(document.getElementById('tour_resourceeditor_addaiservice')){
          tempStep = tempStep.filter(step => step.element === '#tour_resourceeditor_addaiservice');
        }else{
          tempStep =[];
        }
    }
    if (isHeaderTour && !document.getElementById('tour_resourceeditor_addaiservice')) {
      tempStep = tempStep.filter(step => step.element !== "#tour_resourceeditor_addaiservice");
    }
 }
      if(showStudioTour?.isTourForcreateTemp!==undefined || showStudioTour?.isTourForcreateTemp ==="true"){
        tempStep = tempStep;
  }
       // Initialize driver.js and define your tour steps
       const tour = new driver({
         // Your configuration options here
         allowClose: true,
         showProgress: true,
         nextBtnText: 'Next',
         prevBtnText: 'Previous',
         doneBtnText: 'Close',
         
           onNextClick:() => {
            //  console.log('Next Button Clicked');
             handleProductTourEvents(getProductTourReqConfig,axiosFetch,tour?.getActiveStep().popover.title,eventSubModule,"PRODUCT_TOUR");
             if (tour.isLastStep()) {
               // handleProductTourEvents(getProductTourReqConfig,axiosFetch,"Tour_End",eventSubModule,"PRODUCT_TOUR");
                dispatch(setWorkspaceData({ isWelcomeWindowOpen: false, isHeaderTour:false,isTourForProfessionalFlow:false,isTourFirstUser:false}));
                if(eventSubModule==="APP_TEMPLATE"){
                  dispatch(setWorkspaceData({tourForApptemplate:false}));
                }
              //  console.log('Last step Next Button Clicked');              
              }
             tour.moveNext();
           },
           onPrevClick:() => {
             //console.log('Previous Button Clicked');
             handleProductTourEvents(getProductTourReqConfig,axiosFetch,tour.getActiveStep().popover.title,eventSubModule,"PRODUCT_TOUR");
             tour.movePrevious();
           },
           onCloseClick:() => {
            // console.log('Close Button Clicked');
             dispatch(setWorkspaceData({ isWelcomeWindowOpen: false, isHeaderTour:false,isTourForProfessionalFlow:false,isTourFirstUser:false}));
             if(eventSubModule==="APP_TEMPLATE"){
              dispatch(setWorkspaceData({tourForApptemplate:false}));
            }
             handleProductTourEvents(getProductTourReqConfig,axiosFetch,"Tour_Closed",eventSubModule,"PRODUCT_TOUR");
             tour.destroy();
           },

           onDestroyStarted: () => {
            if (!tour.hasNextStep()) {
              dispatch(setWorkspaceData({ isWelcomeWindowOpen: false, isHeaderTour:false,isTourForProfessionalFlow:false,isTourFirstUser:false}));
              if(eventSubModule==="APP_TEMPLATE"){
                dispatch(setWorkspaceData({tourForApptemplate:false}));
              }
              handleProductTourEvents(getProductTourReqConfig,axiosFetch,"Tour_End",eventSubModule,"PRODUCT_TOUR");
              tour.destroy();
            }
          },
   
         steps: tempStep,
       });
   
       // Start the tour
       tourRef.current = tour;
       tour.drive();
   
       // Cleanup when the component unmounts or when workspacetour becomes false
       return () => {
         tour.destroy();
         tourRef.current = null; // Reset tourRef.current
       };
  }
  return ({tourGuide})
}

export default ProductTour